import React, { useEffect, useRef, useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import Typewriter from 'typewriter-effect';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        toggle.current?.focus();
      }
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [open]);

  return (
    <header className="portfolio__navbar">
      <Link className="portfolio__navbar-brand" to="/" aria-label="Fabián Ortega — Inicio" onClick={() => setOpen(false)}>
        <span className="portfolio__navbar_brand_typewriter" aria-hidden="true">
          <Typewriter options={{
            strings: ['Fabián Ortega', 'Data Scientist', 'Data Analyst'],
            delay: 90, pauseFor: 2000, deleteSpeed: 90, autoStart: true, loop: true,
          }} />
        </span>
      </Link>
      <button
        ref={toggle}
        type="button"
        className="portfolio__navbar-toggle"
        aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
        aria-expanded={open}
        aria-controls="portfolio-navigation"
        onClick={() => setOpen((value) => !value)}
      >
        {open ? <RiCloseLine size={27} aria-hidden="true" /> : <RiMenu3Line size={27} aria-hidden="true" />}
      </button>
      <nav id="portfolio-navigation" className={`portfolio__navbar-navigation${open ? ' is-open' : ''}`} aria-label="Principal">
        <Link to="/about-me" onClick={() => setOpen(false)}>Acerca de mí</Link>
        <Link to="/projects" onClick={() => setOpen(false)}>Proyectos</Link>
        <Link to="/data-viz" onClick={() => setOpen(false)}>Data Viz</Link>
      </nav>
    </header>
  );
};

export default Navbar;
